import React from "react";
import Header from "../components/Header/Header";
// import Layout from "../components/layout/Layout";
import Layout from "../components/Layout/Layout";
import Login from "../components/User/SignIn/SignIn";
import styled, { css } from "styled-components";

const SignIn = () => {
  return <Login />;
};

export default SignIn;
